import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Suppresses / un-suppresses future sends to a bounced address.
 * `suppressed` has no server-side default, so it is always sent explicitly —
 * omitting it returns a 400. A downstream failure here can surface as a raw
 * 500 (unlike the list endpoint, which swallows errors into an empty array),
 * so the caller should surface the error and revert its optimistic update.
 */
const updateBouncedEmailSuppression = (
  email,
  suppressed,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/bounced-emails/${encodeURIComponent(email)}/suppress`,
            null,
            {
              params: {
                'request-id': reqId,
                suppressed,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to update suppression');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback('Failed to update suppression');
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to update suppression');
    }
  };
};

export default updateBouncedEmailSuppression;
